import { Component, OnInit } from '@angular/core';
import { DeviceInfoService } from '../../services/device-info.service';
import { TranslationService } from '../../services/translation.service';
function _window(){
  return window;
}
@Component({
  selector: 'app-pwa-installer',
  templateUrl: './pwa-installer.component.html',
  styleUrls: ['./pwa-installer.component.scss']
})
export class PwaInstallerComponent implements OnInit {

	window :any;
	promptDismissed : boolean = false;
	visible : boolean = false;
  style : 'desktop'|'android'|'ipad'|'iphone'|'default'='default';
  constructor(
    private deviceInfo: DeviceInfoService,
    private translator: TranslationService
    ) {

    if(this.deviceInfo.isIos()){
          if(this.deviceInfo.isIPad()){
            this.style = 'ipad';
          }
          if( this.deviceInfo.isIPhone() || this.deviceInfo.isIPod() ){
            this.style='iphone';
          }
    }else{
      if(this.deviceInfo.isMobile()){
        this.style = 'android';
      }else{
        this.style = 'desktop';
      }
    }
    if( ['android','desktop'].includes(this.style) ){
      this.style='default';
    }
    
    
    this.window = _window();
    setTimeout(
  		()=>{
  			this.showInstallerPrompt();
  	},3000);
  }
  deviceType(){
    return this.style;
  }
  translate(phrase:string,idx?:number){
    if(idx === undefined){
      return this.translator.tr(phrase);
    }else{
      return this.translator.tr(phrase).split('<icon>')[idx];
    }
    
  }
  showInstallerPrompt(){
  	this.visible=true;
  	setTimeout(()=>{
  		this.visible=false;
  	},10000);
  }
  installationAvailable(){
    
    if (this.window.matchMedia('(display-mode: standalone)').matches) {
      return false;
    }
    if (this.window.navigator.standalone === true) {
      return false;
    }
    if(this.window.deferredInstallPrompt){
      return true;
    }
    if(this.deviceInfo.isIos()){
      return true;
    }

	  return false;
  }
  promptVisible(){
  	return this.installationAvailable() && !this.promptDismissed && this.visible;
  }
  install(){
  	if(this.installationAvailable()){
  		this.window.deferredInstallPrompt.prompt();
  	}
  }
  ngOnInit() {
  }

}

